import type { ReactNode } from "react";

export function Frame({ children, bg }: { children: ReactNode; bg?: string }) {
  return (
    <div className="home-frame" style={bg ? { background: bg } : undefined}>
      {children}
    </div>
  );
}
